export const INITIAL_STATE = {
  data: null,
  isFetching: false,
  finish: false,
  error: false,
  progress: 0,
};

export const progress = (state, action) => {
  return {
    ...state,
    progress: action.progress,
  };
};

export const request = (state, action) => {
  return {
    ...state,
    isFetching: true,
  };
};

export const success = (state, action) => {
  return {
    ...state,
    data: action.data,
    finish: true,
    isFetching: false,
    error: false,
  };
};

export const failure = (state, action) => {
  return {
    ...state,
    data: action.errData,
    finish: true,
    isFetching: false,
    error: true,
  };
};

export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "REQ_UPLOAD_FILE_CLAIM":
      return request(state, action);
    case "REQ_UPLOAD_FILE_CLAIM_PROGRESS":
      return progress(state, action);
    case "REQ_UPLOAD_FILE_CLAIM_SUCCESS":
      return success(state, action);
    case "REQ_UPLOAD_FILE_CLAIM_FAILED":
      return failure(state, action);
    case "RESET_REQ_UPLOAD_FILE_CLAIM":
      return INITIAL_STATE;
    default:
      return state;
  }
};
